import { render, staticRenderFns } from "./TournamentWatchLiveSmall.vue?vue&type=template&id=cea1888a&functional=true&"
import script from "./TournamentWatchLiveSmall.vue?vue&type=script&lang=js&"
export * from "./TournamentWatchLiveSmall.vue?vue&type=script&lang=js&"
import style0 from "./TournamentWatchLiveSmall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cea1888a')) {
      api.createRecord('cea1888a', component.options)
    } else {
      api.rerender('cea1888a', component.options)
    }
    module.hot.accept("./TournamentWatchLiveSmall.vue?vue&type=template&id=cea1888a&functional=true&", function () {
      api.rerender('cea1888a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tournament/TournamentWatchLiveSmall.vue"
export default component.exports